import { formatMoney } from '../../components/utilities';
import UploadImage from '../../components/uploadImage';

const Customizations = {
  firstOpen: true,
  totalValue: 0,
  allowSubmit: true,
  inputsToFill: [],

  //Atualiza o preço considerando todas as opções habilitadas
  updatPrice: function (target) {
    const displayValue = document.querySelectorAll('[data-customization-value]');
    const inputs = target.querySelectorAll('input');

    const attributeValue = target.getAttribute('data-content');
    const customPriceElement = document.querySelector(`[data-price-custom="${attributeValue}"]`);

    if (displayValue.length <= 0) return;
    inputs.forEach((input) => {
      const type = input.getAttribute('type');
      const value = Number(input.getAttribute('data-customization-price'));

      // Separa validação por input de seleção e input de texto
      if (value > 0) {
        if (type === 'radio' || type === 'checkbox') {
          if (input.checked && !input.disabled) {
            Customizations.totalValue += value;
          } else if (input.checked && input.disabled) {
            Customizations.totalValue -= value;
          }
        } else if (type === 'text' || type === 'textarea') {
          if (!input.disabled) {
            Customizations.totalValue += value;
          } else {
            Customizations.totalValue -= value;
          }
        }
      }

      if (target.getAttribute('data-content') == customPriceElement.getAttribute('data-price-custom')) {
        // Verifica se o elemento já tem algum valor de texto
        if (customPriceElement.innerText.trim() == '') {
          if (value > 0) {
            customPriceElement.innerText = `${formatMoney(value)}`;
          }
        }
      }
    });

    if (Customizations.totalValue > 0) {
      displayValue.forEach((el) => {
        el.innerText = `+ ${formatMoney(Customizations.totalValue)}`;
      });
    } else {
      displayValue.forEach((el) => {
        el.innerText = '';
      });
      Customizations.totalValue = 0;
    }
  },

  // Marca a primeira opção das customizações que possuem mais de uma opção
  markFirstOption: function () {
    const customs = document.querySelectorAll('[data-custom-option]');
    customs.forEach((custom) => {
      const inputs = custom.querySelectorAll('input[type="radio"], input[type="checkbox"]');
      if (inputs.length > 0) {
        const firstAvailable = custom.querySelector('.label.-available');

        if (inputs.length == 1) {
          let first_input = inputs[0];
          let parentElement = first_input.closest('.logo-customization');

          if (parentElement && parentElement.classList.contains('-active')) {
            first_input.click();
          }
        }

        if (!firstAvailable) return;

        const hasColor = firstAvailable.getAttribute('has-color');
        if (firstAvailable && hasColor != 'true') firstAvailable.click();
      }
    });
  },

  //Controla o click nas checkboxes de cada grupo de personalização
  handleCheckboxes: function () {
    const checkboxes = document.querySelectorAll('.customization-popup [data-toggle]');

    checkboxes &&
      checkboxes.forEach((checkbox) => {
        const target = document.querySelector(`.customization-popup [data-content="${checkbox.dataset.toggle}"]`);

        if (target) {
          checkbox.checked = true;

          Customizations.checkListClicks(target, checkbox);
          Customizations.toggleCustomizationGroups(target, checkbox);
          Customizations.toggleInputs(target, checkbox);
          Customizations.toggleLogoForm(checkbox);
          Customizations.markFirstOption();
          Customizations.updatPrice(target);

          checkbox.addEventListener('change', () => {
            Customizations.toggleCustomizationGroups(target, checkbox);
            Customizations.toggleInputs(target, checkbox);
            Customizations.toggleLogoForm(checkbox);
            Customizations.updatPrice(target);
          });
        }
      });
  },

  //Habilita / desabilita todos os inputs obrigatórios quando o grupo de personalização é selecionada ou não
  toggleInputs: function (target, checkbox) {
    const inputs = target.querySelectorAll('input');
    const checkboxEscrita = document.querySelector('#pers-escrita');
    const labels = document.querySelectorAll('.logo-customization [data-label]');

    labels.forEach((label) => {
      // Verifica se checkboxEscrita existe antes de usar .checked
      if (checkboxEscrita && label.getAttribute('data-label') == 'peito' && checkboxEscrita.checked) {
        label.classList.remove('-available');
        label.classList.add('-unavailable');
      } else {
        label.classList.add('-available');
        label.classList.remove('-unavailable');
      }
    });

    inputs.forEach((input) => {
      if (checkbox.checked) {
        input.disabled = false;
        if (input.hasAttribute('data-disabled')) input.disabled = true;
      } else {
        input.disabled = true;
      }
    });
  },

  //Monitora clicks nas listas para atualizar a altura do container quando uma lista expande
  checkListClicks: function (target, checkbox) {
    const lists = document.querySelectorAll('.customization-popup .list');

    lists &&
      lists.forEach((list) => {
        list.addEventListener('click', () => {
          Customizations.toggleCustomizationGroups(target, checkbox);
        });
      });
  },

  //Gerencia a exibição visual do grupo de personalização selecionado
  toggleCustomizationGroups: function (target, checkbox) {
    if (checkbox.checked) {
      target.style.height = `${target.scrollHeight}px`;
      target.classList.add('-active');
    } else {
      target.style.height = 0;
      target.classList.remove('-active');
    }
  },

  //Preenche o input de id verificador quando uma imagem é enviada
  checkImageSelection: function (link) {
    // const fileInputs = document.querySelectorAll('[data-customizations-file]');
    const attachmentsIdInput = document.querySelector('[data-customization-attachments-id]');
    const customizationsLogoForm = document.getElementById('customization-webform');

    // fileInputs.length > 0 && fileInputs.forEach((input) => (input.disabled = false));

    if (attachmentsIdInput) {
      attachmentsIdInput.disabled = false;
      attachmentsIdInput.value = '';
      // Identificador
      const customizationIdentifier = Math.random().toString(36).slice(2, 11);
      attachmentsIdInput.value = link;
    }

    if (customizationsLogoForm) {
      customizationsLogoForm.classList.add('-submit-allowed');
    }
  },

  toggleLogoForm: function (checkbox) {
    const customizationsLogoForm = document.getElementById('customization-webform');
    const checkboxTarget = checkbox.dataset.toggle;

    if (customizationsLogoForm && checkboxTarget == 'logo') {
      if (checkbox.checked) {
        customizationsLogoForm.classList.add('-submit-allowed');
      } else {
        customizationsLogoForm.classList.remove('-submit-allowed');
      }
    }
  },

  // Manipula o envio dos arquivos
  handleFileUpload: async function () {
    const sectionProduct = document.querySelector('[data-section-product]');
    const inputsFile = sectionProduct.querySelectorAll('[data-customizations-file]');
    const dropZones = sectionProduct.querySelectorAll('[data-customizations-dropzone]');
    const webform = sectionProduct.querySelector('[data-customizations-webform]');

    // Verifica elementos de personalização no produto
    if (inputsFile.length > 0 && dropZones.length > 0) {
      const handleFiles = async (file, warning, error, display) => {
        // Verifica formato dos arquivos
        const isValidFile = UploadImage.validateFile(file);

        console.log('isValidFile', isValidFile);

        // Se não tem "arquivos errados" ele continua
        if (isValidFile) {
          // Armazena nome(s) do(s) arquivo(s)
          const name = file[0].name;

          // Envia o arquivo para o Cloudinary
          const link = await UploadImage.upload(file[0]);

          console.log('link', link);

          // Retorna o link para ser inserido como valor do atributo personalizado "anexo-indicador"
          this.checkImageSelection(link);

          // Atualiza elementos informativos
          if (display) display.innerHTML = name;
          if (warning) warning.classList.add('-active');
        } else if (error) {
          // Exibe mensagem de erro referente ao formato dos arquivos
          error.classList.add('-active');
          setTimeout(() => {
            error.classList.remove('-active');
          }, 5000);
        }
      };

      // Botão para envio de arquivos
      inputsFile.forEach((inputFile) => {
        inputFile.addEventListener('change', (e) => {
          console.log('hello world');
          e.preventDefault();

          const display = inputFile.closest('[data-custom-option]').querySelector('[data-customizations-display]');
          const messageWarning = inputFile
            .closest('[data-custom-option]')
            .querySelector('[data-customizations-message-warning]');
          const messageError = inputFile
            .closest('[data-custom-option]')
            .querySelector('[data-customizations-message-error]');

          console.log('e.target.files', e.target.files);
          if (e.target.files) handleFiles([...e.target.files], messageWarning, messageError, display);
        });
      });

      // Arrastar o arquivo até o campo de upload
      dropZones.forEach((dropZone) => {
        dropZone.addEventListener('dragover', (e) => {
          e.preventDefault();
        });
        dropZone.addEventListener('drop', (e) => {
          e.preventDefault();

          const display = dropZone.closest('[data-custom-option]').querySelector('[data-customizations-display]');
          const messageWarning = dropZone
            .closest('[data-custom-option]')
            .querySelector('[data-customizations-message-warning]');
          const messageError = dropZone
            .closest('[data-custom-option]')
            .querySelector('[data-customizations-message-error]');

          const files = e.dataTransfer.items
            ? [...e.dataTransfer.items].filter((item) => item.kind === 'file').map((item) => item.getAsFile())
            : e.dataTransfer.files
            ? [...e.dataTransfer.files]
            : [];

          if (files.length > 0) handleFiles(files, messageWarning, messageError, display);
        });
      });
    }
  },

  //Fecha o popup caso todos os inputs required estiverem preenchidos. Caso contrário, destacas os inputs que faltam
  confirmCustomizations: function () {
    const button = document.querySelector('[data-customization-confirm]');
    const popups = document.querySelectorAll('[data-popup-customization]');

    button &&
      button.addEventListener('click', () => {
        const alertMsg = document.querySelector('.customization-popup [data-customization-alert]');

        Customizations.verifyRequiredInputs();

        if (Customizations.allowSubmit) {
          popups.forEach((popup) => {
            popup.classList.toggle('-active');
          });
          document.body.classList.toggle('-blocked');
        } else {
          if (alertMsg) {
            alertMsg.innerText = 'Preencha os campos obrigatórios';
            alertMsg.style.display = 'flex';
          }
          button.style.pointerEvents = 'none';

          Customizations.inputsToFill.forEach((input) => {
            let container = input.closest('[data-custom-option]');
            if (container) {
              container.style.color = 'red';
            }
          });

          setTimeout(() => {
            if (alertMsg) {
              alertMsg.innerText = '';
              alertMsg.style.display = 'none';
            }

            Customizations.inputsToFill.forEach((input) => {
              let container = input.closest('[data-custom-option]');
              if (container) {
                container.style.color = 'unset';
              }
            });

            button.style.pointerEvents = 'all';
          }, 2000);
        }
      });
  },

  //Verifica se os inputs required estão preenchidos
  verifyRequiredInputs: function () {
    Customizations.allowSubmit = true;
    Customizations.inputsToFill = [];
    const requiredInputs = document.querySelectorAll('.customization-popup input[required]:not([disabled])');

    // Set para armazenar os grupos já verificados
    const checkedRadioGroups = new Set();

    requiredInputs.forEach((input) => {
      const type = input.getAttribute('type');
      const name = input.getAttribute('name');

      if (type === 'radio') {
        // Ignora se o grupo já foi verificado
        if (checkedRadioGroups.has(name)) return;

        // Verifica se algum input do grupo já está marcado
        const group = document.querySelectorAll(`.customization-popup input[name="${name}"]:not([disabled])`);
        const isGroupChecked = Array.from(group).some((radio) => radio.checked);

        // Se nenhum input do grupo seja marcado
        if (!isGroupChecked) {
          Customizations.allowSubmit = false;
          Customizations.inputsToFill.push(...group);
        }

        checkedRadioGroups.add(name); // Marca o grupo como já verificado
      } else if (type === 'checkbox') {
        if (!input.checked) {
          Customizations.allowSubmit = false;
          Customizations.inputsToFill.push(input);
        }
      } else if (type === 'text' || type === 'textarea') {
        if (input.value == '') {
          Customizations.allowSubmit = false;
          Customizations.inputsToFill.push(input);
        }
      } else if (type === 'file') {
        if (input.files.length <= 0) {
          Customizations.allowSubmit = false;
          Customizations.inputsToFill.push(input);
        }
      }
    });
  },

  //Ao fechar o popup, desabilita todos os inputs requireds que não foram preenchidos
  disableBlankCategories: function () {
    Customizations.verifyRequiredInputs();

    if (Customizations.inputsToFill.length > 0) {
      Customizations.inputsToFill.forEach((input) => {
        const wrapper = input.closest('[data-content]');
        const checkbox = document.querySelector(`.customization-popup [data-toggle="${wrapper.dataset.content}"]`);

        if (checkbox) {
          checkbox.checked = false;

          const event = new Event('change', {
            bubbles: true,
            cancelable: true,
          });

          checkbox.dispatchEvent(event);
        }
      });
    }
  },

  //Exibe / oculta o popup
  togglePopup: function () {
    const popups = document.querySelectorAll('[data-popup-customization]');
    const toggleBtns = document.querySelectorAll('[data-customization-action]');

    if (popups.length > 0) {
      toggleBtns.forEach((toggleBtn) => {
        toggleBtn.addEventListener('click', () => {
          popups.forEach((popup) => {
            if (popup.classList.contains('-active') && popup.classList.contains('customization-popup')) {
              Customizations.disableBlankCategories();
            } else if (popup.classList.contains('customization-popup') && Customizations.firstOpen) {
              Customizations.handleCheckboxes();
              Customizations.firstOpen = false;
            }

            popup.classList.toggle('-active');

            //Dispara um evento de click para os campos de personalização começarem fechados
            const textualToggle = document.querySelector('[data-toggle="textual"]');
            const logoToggle = document.querySelector('[data-toggle="logo"]');

            if (textualToggle) textualToggle.click();
            if (logoToggle) logoToggle.click();
          });
          document.body.classList.toggle('-blocked');
        });
      });
    }
  },

  //Lida com scrolls do popup
  handlePopupScroll: function () {
    const content = document.querySelector('[data-scroll-content]');
    const wrapper = document.querySelector('[data-scroll-wrapper]');
    if (content && wrapper) {
      let lastScrollTop = 0;
      wrapper.addEventListener('scroll', () => {
        if (wrapper.scrollTop > lastScrollTop) {
          if (wrapper.scrollTop == wrapper.scrollTopMax) content.scrollTo(0, content.scrollTopMax);
        } else {
          if (wrapper.scrollTop == 0) content.scrollTo(0, 0);
        }

        lastScrollTop = wrapper.scrollTop;
      });
    }
  },

  //Lida com a fonte do text
  handleFontClothing: function () {
    const textClothingTop = document.querySelector('[data-clothing-text-top]');
    const textClothingBottom = document.querySelector('[data-clothing-text-bottom]');
    const inputFont = document.querySelectorAll('[data-clothing-font]');

    if (inputFont.length > 0)
      inputFont.forEach((font) => {
        font.addEventListener('change', (event) => {
          // Captura o valor do input selecionado
          let selectedValue = event.target.value;

          if (selectedValue === 'Bodoni Moda') {
            textClothingTop.style.fontFamily = `${selectedValue}, serif`;
            textClothingBottom.style.fontFamily = `${selectedValue}, serif`;
          } else {
            textClothingTop.style.fontFamily = `${selectedValue}, sans-serif`;
            textClothingBottom.style.fontFamily = `${selectedValue}, sans-serif`;
          }

          // Aplica a font-family nos textos (sem usar o atalho 'font', para evitar conflitos)
        });
      });
  },

  //Lida com a cor do texto que fica na imagem da personalização
  handleColorClothing: function () {
    const textClothingTop = document.querySelector('[data-clothing-text-top]');
    const textClothingBottom = document.querySelector('[data-clothing-text-bottom]');
    const inputColor = document.querySelectorAll('[data-clothing-color]');

    if (inputColor.length > 0)
      inputColor.forEach((color) => {
        color.addEventListener('change', (event) => {
          // Captura o valor do input selecionado
          let selectedValue = event.target.value;

          if (selectedValue.includes('|')) {
            let colorValue = selectedValue.split('|')[1].trim();

            textClothingTop.style.color = colorValue;
            textClothingBottom.style.color = colorValue;
          }
        });
      });
  },

  //Lida com o lado que fica o texto na imagem da personalização
  handleSideClothing: function () {
    const sides = document.querySelectorAll('[data-clothing-side]');
    const imageClothing = document.querySelector('[data-image-clothing]');

    // Função para verificar qual lado está selecionado e pegar o data attribute
    function checkSelectedSide() {
      let selectedSide;

      // Remove qualquer classe que comece com 'side-'
      imageClothing.classList.forEach((className) => {
        if (className.startsWith('side-')) {
          imageClothing.classList.remove(className);
        }
      });

      // Verifica o rádio selecionado e adiciona a classe correspondente
      sides.forEach((radio) => {
        if (radio.checked) {
          selectedSide = radio.getAttribute('data-clothing-side');
          imageClothing.classList.add(`side-${selectedSide}`);
        }
      });

      return selectedSide;
    }

    // Verifica qual botão está selecionado ao carregar a página
    document.addEventListener('DOMContentLoaded', checkSelectedSide);

    if (sides.length > 0)
      sides.forEach((side) => {
        side.addEventListener('click', checkSelectedSide);
      });
  },

  //Lida com o texto que fica na imagem da personalização
  handleTextClothing: function () {
    const custominization = document.querySelectorAll('.prod-option.-customization.-text');

    if (custominization.length > 0)
      custominization.forEach((custom, i) => {
        const input = custom.querySelector('[data-clothing-line]');

        const outputTop = document.querySelector(`[data-output-top="${i + 1}"]`);
        const outputBottom = document.querySelector(`[data-output-bottom="${i + 1}"]`);

        // Adiciona o evento 'input' ao campo de texto
        if (input)
          input.addEventListener('input', () => {
            outputTop.textContent = input.value;
            outputBottom.textContent = input.value;
          });
      });
  },

  init: function () {
    const inputFiles = document.querySelectorAll('input[data-customizations-file]');

    inputFiles.forEach((inputFile) => {
      inputFile.addEventListener('change', () => {
        Customizations.checkImageSelection();
      });
    });

    this.handleFileUpload();
    this.confirmCustomizations();
    this.togglePopup();
    this.handlePopupScroll();
    this.handleFontClothing();
    this.handleColorClothing();
    this.handleSideClothing();
    this.handleTextClothing();
  },
};

export default Customizations;
